module.exports = fox._r("fonts/museosanscyrl_1-webfont.svg", __webpack_public_path__ + "fonts/museosanscyrl_1-webfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl_1-webfont.svg
// module id = 583
// module chunks = 2